// Saved views for Quality Contract Performance.
// Built-in presets + user-saved views in localStorage.

const STORAGE_KEY = 'quality_contract_performance_user_views_v1';
const LAST_VIEW_KEY = 'quality_contract_performance_last_view_v1';

export const BUILTIN_PRESETS = [
  {
    key: 'default',
    name: 'Default',
    state: {
      performanceYears: [2026],
      selectedContractIds: [],
      selectedPayerNames: [],
      selectedMeasureCodes: [],
      groupChips: ['contract'],
      entityFilters: null,
    },
  },
];

export function loadUserViews() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveUserViews(views) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(views));
}

export function loadLastViewKey() {
  return localStorage.getItem(LAST_VIEW_KEY);
}

export function saveLastViewKey(key) {
  if (key) localStorage.setItem(LAST_VIEW_KEY, key);
  else localStorage.removeItem(LAST_VIEW_KEY);
}
